import { IReceipt } from 'src/types/Receipt';
import axios from 'src/utils/axios';

import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'src/app/store';
type receiptDataState = {
  receiptData: IReceipt;
  receiptDataLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
  cancelReceiptData: IReceipt | undefined;
  cancelReceiptLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
  saveReceiptData: Object;
  saveReceiptLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
  completeReceiptData: Object;
  completeReceiptLoading: 'loading' | 'pending' | 'succeeded' | 'failed';
};

const initialState = {
  receiptData: {},
  receiptDataLoading: 'loading',
  cancelReceiptData: {},
  cancelReceiptLoading: 'loading',
  saveReceiptData: {},
  saveReceiptLoading: 'loading',
  completeReceiptData: {},
  completeReceiptLoading: 'loading',
} as receiptDataState;

export const fetchReceiptData = createAsyncThunk(
  'Receipt/fetchReceiptData',
  async (receivingReceiptId: number | undefined) => {
    const response = await axios.get(`/Receipt/${receivingReceiptId}`);
    return response.data;
  }
);

export const cancelReceipt = createAsyncThunk('Receipt/Cancel', async (ids: number[]) => {
  const response = await axios.post(`/Receipt/Cancel`, ids);
  return response.data;
});

export const saveReceipt = createAsyncThunk(
  'Receipt/Save',
  async ({ receivingReceiptId, saveData }: any) => {
    const response = await axios.put(`/Receipt/${receivingReceiptId}`, saveData);
    return response.data;
  }
);

export const completeReceipt = createAsyncThunk('Receipt/Complete', async (ids: any) => {
  const response = await axios.post(`/Receipt/Complete`, ids);
  return response.data;
});

export const receiptSlice = createSlice({
  name: 'Receipt',
  initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReceiptData.fulfilled, (state, action: PayloadAction<IReceipt>) => {
        state.receiptData = action.payload;
        state.receiptDataLoading = 'succeeded';
      })
      .addCase(fetchReceiptData.rejected, (state) => {
        state.receiptDataLoading = 'failed';
      })
      .addCase(fetchReceiptData.pending, (state) => {
        state.receiptDataLoading = 'pending';
      })
      .addCase(cancelReceipt.fulfilled, (state, action: PayloadAction<IReceipt>) => {
        state.cancelReceiptData = action.payload;
        state.cancelReceiptLoading = 'succeeded';
      })
      .addCase(cancelReceipt.rejected, (state) => {
        state.cancelReceiptLoading = 'failed';
      })
      .addCase(cancelReceipt.pending, (state) => {
        state.cancelReceiptLoading = 'pending';
      })
      .addCase(saveReceipt.fulfilled, (state, action: PayloadAction<any>) => {
        state.saveReceiptData = action.payload;
        state.saveReceiptLoading = 'succeeded';
      })
      .addCase(saveReceipt.rejected, (state) => {
        state.saveReceiptLoading = 'failed';
      })
      .addCase(saveReceipt.pending, (state) => {
        state.saveReceiptLoading = 'pending';
      })
      .addCase(completeReceipt.fulfilled, (state, action: PayloadAction<any>) => {
        state.completeReceiptData = action.payload;
        state.completeReceiptLoading = 'succeeded';
      })
      .addCase(completeReceipt.rejected, (state) => {
        state.completeReceiptLoading = 'failed';
      })
      .addCase(completeReceipt.pending, (state) => {
        state.completeReceiptLoading = 'pending';
      });
  },
});

export const selectReceiptUse = (state: RootState) => state.receipt;
export default receiptSlice.reducer;
